import { defineGameCard } from '../authoring/index.js';
import { slimeDependencies, trail } from './slime-helpers.js';
export const LeakingClotCard = defineGameCard({
    id: 'leaking_clot',
    gameplay: { type: 'UNIT', cost: 2, baseStats: { attack: 3, health: 1 }, traits: ['SLIME'] },
    presentation: {
        name: 'Протекающий сгусток',
        description: 'След 3.',
        glyph: {
            colors: ['#10213A', '#3A624D', '#5E984F', '#74AD4C', '#96C653'],
            rows: [
                '......11..11........',
                '.....12311421.......',
                '......134421........',
                '.....1314141........',
                '.....14444431.......',
                '.....144244311......',
                '.....154444422111...',
                '.....1554444333221..',
                '......155255533331..',
                '......122222222221..',
                '.......1111111111...',
                '.....115544444441...',
                '....154444111111....',
                '....1555554444111...',
                '.....1111155444551..',
                '...1111111111144431.',
                '.112223445555443321.',
                '135333444444433221..',
                '12335544455511111...',
                '.11111111111........',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeDependencies(),
    abilities: [trail(3)],
    ui: { mechanics: ['trail', 'slime_residue'] },
});
//# sourceMappingURL=leaking_clot.js.map